import { Module } from 'vuex'
import axios from 'axios'
import { BASE_API_URL } from '@/config'
export interface Company {
  id: number
  name: string
}
export interface AddCompany {
  name: string
}
export type EditCompany = Company
export interface CompanyStore {
  companies: Company[]
}
export const companyStore: Module<CompanyStore, {}> = {
  namespaced: true,
  state: () => ({
    companies: []
  }),
  mutations: {
    loadCompanies(state, payload: Company[]) {
      state.companies = payload
    }
  },
  actions: {
    async loadCompanies({ commit }) {
      const { data } = await axios.get(`${BASE_API_URL}/company`)
      commit('loadCompanies', data)
    },
    async addCompany(_, payload: AddCompany) {
      const { data } = await axios.post(`${BASE_API_URL}/company`, payload)
      return data
    },
    async editCompany({ dispatch }, { id, name }: EditCompany) {
      const { data } = await axios.put(`${BASE_API_URL}/company/${id}`, {
        name
      })
      await dispatch('loadCompanies')
      return data
    },
    async getCompany(_, id: string) {
      const { data } = await axios.get(`${BASE_API_URL}/company/${id}`)
      return data
    }
  },
  getters: {
    companies: state => state.companies
  }
}
